import { User as SupabaseUser } from "@supabase/supabase-js";

// Extend Supabase User to include properties from Auth0 migration
export interface User extends SupabaseUser {
  sub?: string; // Auth0 subject identifier (same as id)
}

// Helper to convert Supabase user to our User type
export function toUser(supabaseUser: SupabaseUser | null): User | null {
  if (!supabaseUser) return null;

  return {
    ...supabaseUser,
    sub: supabaseUser.id, // Map Supabase id to Auth0 sub
  };
}

// Auth data with extended user
export interface AuthData {
  user: User | null;
  loading: boolean;
  error: Error | null;
  signOut: () => Promise<void>;
  refetch: () => void;
  getAccessToken?: () => Promise<string | null>;
}

// Helper to get access token from Supabase session
export async function getAccessToken(): Promise<string | null> {
  const { supabase } = await import("@/shared/lib/supabase");
  const {
    data: { session },
  } = await supabase.auth.getSession();
  return session?.access_token || null;
}
